import { baseRestApi } from "api/rest/baseRestApi";
import { ApiResponse, UrlParam } from "api/rest/types/responses";

import { ShipperQuoteRequest } from "./types";

type UrlParams = {
  quoteRequestId: UrlParam;
};

type BodyParams = {
  templateName?: string;
};

type QueryArgs = {
  urlParams: UrlParams;
  body: BodyParams;
};

type ResponseType = ApiResponse<ShipperQuoteRequest>;

module.hot?.accept();

export const createTemplateFromQuoteRequest = baseRestApi
  .enhanceEndpoints({ addTagTypes: ["QUOTE_REQUESTS", "SOURCES"] })
  .injectEndpoints({
    overrideExisting: module.hot?.status() === "apply",
    endpoints: (builder) => ({
      createTemplateFromQuoteRequest: builder.mutation<ResponseType, QueryArgs>({
        query: ({ urlParams, body }) => ({
          method: "POST",
          url: `shipper/quote-requests/${urlParams.quoteRequestId}/template`,
          body,
        }),
        invalidatesTags: ["QUOTE_REQUESTS", "SOURCES"],
      }),
    }),
  });

export const { useCreateTemplateFromQuoteRequestMutation } = createTemplateFromQuoteRequest;
export type DuplicateQuoteRequestBody = BodyParams;
